// extracted by mini-css-extract-plugin
module.exports = {"tip":"tip___2wOLg","icon":"icon___1ebUo","text":"text___1hsZl"};